import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PyramidSettings } from 'src/app/models/pyramid.interface';
import { pyramidCowBacteriaSettings } from 'src/app/modules/pyramid-cow-bacteria/pyramid-cow-bacteria-settings';
import { pyramidEmergencySettings } from 'src/app/modules/pyramid-emergency/pyramid-emergency-settings';
import { pyramidEnvironmentBacteriaSettings } from 'src/app/modules/pyramid-environment-bacteria/pyramid-environment-bacteria-settings';
import { pyramidRobotCowBacteriaSettings } from 'src/app/modules/pyramid-robot-cow-bacteria/pyramid-robot-cow-bacteria-settings';
import { pyramidRobotEnvironmentBacteriaSettings } from 'src/app/modules/pyramid-robot-environment-bacteria/pyramid-robot-environment-bacteria-settings';
import { pyramidSummerPeakSettings } from 'src/app/modules/pyramid-summer-peak/pyramid-summer-peak-settings';

@Component({
  templateUrl: './all-pyramids.component.html',
  styleUrls: ['./all-pyramids.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllPyramidsComponent {
  pyramids: Array<PyramidSettings> = [
    pyramidEmergencySettings,
    pyramidCowBacteriaSettings,
    pyramidEnvironmentBacteriaSettings,
    pyramidRobotCowBacteriaSettings,
    pyramidRobotEnvironmentBacteriaSettings,
    pyramidSummerPeakSettings,
  ];
}
